import { sentryCreateBrowserRouter } from 'lib/sentry';
import { lazy, Suspense, PropsWithChildren } from 'react';
import { Navigate } from 'react-router';
import { AppShell } from '../layout/AppShell';
import { LoginPage } from '../pages/LoginPage';
import { AuthGuard } from './AuthGuard';

const GraphPage = lazy(() => import('../pages/GraphPage'));
const NotFoundPage = lazy(() => import('../pages/NotFoundPage'));
const SummaryPage = lazy(() => import('../pages/SummaryPage'));
const UserPage = lazy(() => import('../pages/UserPage'));
const UserDetailPage = lazy(() => import('../pages/UserDetailPage'));
const UserSettingPage = lazy(() => import('../pages/PasswordChangePage'));
const UnexpectedErrorPage = lazy(() => import('../pages/UnexpectedPage'));
const ManualPage = lazy(() => import('../pages/ManualPage'));

export const router = sentryCreateBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: <AppShell />,
    errorElement: <UnexpectedErrorPage />,
    children: [
      {
        path: '/',
        element: (
          <RouteWrapper>
            <SummaryPage />
          </RouteWrapper>
        ),
      },
      {
        path: '/graph',
        element: (
          <RouteWrapper>
            <GraphPage />
          </RouteWrapper>
        ),
      },
      {
        // 目次ページと章ごとの個別ページ（`/manual/login` 等）
        path: '/manual/:slug?',
        element: (
          <RouteWrapper>
            <ManualPage />
          </RouteWrapper>
        ),
      },
      {
        path: '/notfound',
        element: (
          <RouteWrapper>
            <NotFoundPage />
          </RouteWrapper>
        ),
      },
      {
        path: '*',
        element: <Navigate to={'notfound'} replace />,
      },
      {
        path: '/profile',
        element: (
          <RouteWrapper>
            <UserPage />
          </RouteWrapper>
        ),
        children: [
          {
            index: true,
            element: <UserDetailPage />,
          },
          {
            path: 'detail',
            element: <UserDetailPage />,
          },
          {
            path: 'setting',
            element: <UserSettingPage />,
          },
        ],
      },
    ],
  },
]);

function RouteWrapper({ children }: PropsWithChildren) {
  return (
    <AuthGuard redirectTo='/login'>
      <Suspense fallback={null}>{children}</Suspense>
    </AuthGuard>
  );
}
